import { faFaceAwesome } from '@fortawesome/pro-solid-svg-icons'

import { ActionButton } from 'Components/_theme'

import { Heading } from '../Heading/Heading'

export const ActionButtonPresentation = () => (
  <div>
    <Heading size={4}> Action Buttons:</Heading>

    <div className="action-wrapper d-flex pt-4">
      {/* *** Action button *** */}

      <ActionButton icon={faFaceAwesome}>Action Button!</ActionButton>

      {/* *** Action button disabled *** */}

      <ActionButton disabled icon={faFaceAwesome}>
        Action Button!
      </ActionButton>

      {/* *** Action button danger *** */}

      <ActionButton icon={faFaceAwesome} variant="danger">
        Action Button!
      </ActionButton>

      {/* *** Action button danger disabled *** */}

      <ActionButton disabled icon={faFaceAwesome} variant="danger">
        Action Button!
      </ActionButton>
    </div>
  </div>
)
